import { atom } from 'recoil'
import { AlertData } from './types'

export const currentAlertState = atom<AlertData[]>({
  key: 'CurrentAlertState',
  default: [],
})
